export default __webpack_public_path__ + "static/char-18-anr-550449ff7c763130668291ec586430c4.webp";